import moment from "moment/moment";

const AttendanceTable = ({ attendance }) => {
  return (
    <div className="card mt-10 p-0 all-cards">
      <div className="card-header bg-white py-6">
        <h5 className="mb-0">Today's Attendance</h5>
      </div>

      <div className="card-body table-responsive p-4">
        <table
          className="table table-hover m-0 table-bordered"
          id="commontable"
        >
          <thead className="theadheading">
            <tr>
              <th>Employee Id</th>
              <th>Name</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Visits</th>
              <th>Distance</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>

          <tbody>
            {attendance?.length > 0 ? (
              attendance.map((item, index) => (
                <tr key={index}>
                  <td>{item.employeeId}</td>
                  <td>{item.name}</td>
                  <td>
                    {moment.utc(item.checkInTime).local().format("hh:mm A")}
                  </td>
                  <td>
                    {item?.checkOutTime && moment(item.checkOutTime).isValid()
                      ? moment.utc(item.checkOutTime).local().format("hh:mm A")
                      : "-"}
                  </td>
                  <td>{item.visitCount}</td>
                  <td>{item.distanceKm?.toFixed(2)} km</td>
                  {/* <td>
                    <span
                      className={`badge ${
                        item.status === "ACTIVE" ? "bg-success" : "bg-secondary"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6}>
                  <p className="m-0 p-3 text-center font-weight-bold">
                    No Data Found
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceTable;
